<template>

  <div class="content">

    <el-form ref="form" :model="item" :rules="validation" label-width="220px">
      <el-form-item label="Title" prop="title">
        <el-input v-model="item.title" id="title" />
      </el-form-item>

      <el-form-item size="large">
        <el-button type="primary" :loading="loading" @click="onSubmit">
          <span v-if="item._id">Save</span>
          <span v-else>Create</span>
        </el-button>
      </el-form-item>
    </el-form>


  </div>
</template>

<script>
  export default {
    props: ['item'],
    methods: {
      async onSubmit() {
        if (!await this.isValid()) {
          return this.$message.error('Fill field correctly!');
        }
        this.$emit('create');
      },
      async isValid() {
        return new Promise((success) => {
          return this.$refs['form'].validate(valid => success(valid));
        });
      }
    },
    data() {
      return {
        loading: false,
        validation: {
          title: [{required: true, trigger: "blur"}]
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// CreateRoomDialog.vue?e8dbf376